<div class="header-mainInfo">
  <div style="line-height: 1.2; padding-top: 2px;">
    {{materia.nombreCompleto}}
  </div>
</div>
